'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    LanguagePicker: {
        header: 'Escoge un idioma'
    },
    Menu: {
        elem1: {
            title: 'Casos',
            items: {
                item1: {
                    title: 'Caso 1',
                    subtitle: '¿Quién bombardeó el hogar de Omran?',
                    image: '/media/image/menu1.png',
                    url: '/quien-bombardeo-hogar-omran/'
                },
                item2: {
                    title: 'Caso 2',
                    subtitle: '¿Quién derribó el MH17?',
                    image: '/media/image/menu2.png',
                    url: '/quien-derribo-mh17/'
                },
                item3: {
                    title: 'Caso 3',
                    subtitle: '¿Quién destruyó el convoy de Urm al Kubra?',
                    image: '/media/image/menu3.jpg',
                    url: '/quien-destruyo-convoy-humanitario/'
                }
            }
        },
        elem2: {
            title: 'Portada',
            url: '/'
        },
        elem3: {
            title: 'Tutoriales',
            url: '/tutoriales/'
        },
        elem4: {
            title: 'Ver el documental',
            url: '/documental/'
        }
    },
    Home: {
        hint: 'Puedes invitar a otros a esta sesión compartiendo la URL',
        h2: 'Cada día, miles de personas publican en las redes sociales<br />testimonios de las injusticias que presencian.',
        h2sub: 'Sus comentarios, imágenes o vídeos son utilizados por una red de ciudadanos para contrastar la información de la que normalmente disponemos. No es necesario tener conocimientos específicos: las herramientas y las fuentes están ahí, a un clic (o dos) de ti.',
        h3: 'Descubre la verdad',
        h4: 'En este documental, en el que tú tendrás que superar retos interactivos, recreamos cómo luchan contra las mentiras.',
        infoTitle: 'Información',
        infoDesc: 'Explicación de cómo funciona',
        titleCase1: 'Descubre la verdad',
        linkCase1: 'quien-bombardeo-hogar-omran/',
        buttonContinue: 'Saltar intro',
        footer: {
            elem1: {
                name: 'EN PORTADA',
                link: 'http://www.rtve.es/television/en-portada/guerra-mentira/',
                icon: 'icon-enportada'
            },
            elem2: {
                name: 'Lab RTVE',
                link: 'http://lab.rtve.es/',
                icon: 'icon-logolab'
            },
            elem3: {
                name: 'CRÉDITOS',
                link: 'creditos/',
                icon: 'icon-enportada'
            }
        },
        instructions: [{
            txt: 'Algunas imágenes pueden dañar tu sensibilidad, como tantas otras imágenes que puedes ver a diario en un informativo',
            icon: 'icon-warning'
        }, {
            txt: 'Este webdoc tiene una navegación conversacional de la que formarás parte',
            icon: 'icon-talk'
        }, {
            txt: 'Mantente alerta, tendrás que resolver un reto interactivo al final de cada conversación',
            icon: 'icon-hand'
        }],
        parallaxContent: [{
            type: 'string',
            velocity: '0.10',
            txt: 'Guerra'
        }, {
            type: 'image',
            velocity: '0.5',
            img: 'lineHome.png'
        }, {
            type: 'string',
            velocity: '0.20',
            txt: 'a la'
        }, {
            type: 'image',
            velocity: '0.30',
            img: 'lineHome.png'
        }, {
            type: 'string',
            velocity: '0.4',
            txt: 'mentira'
        }]
    },
    Mobile: {
        start: 'Empezar',
        connecting: 'Conectando',
        connected: 'Conectado',
        endText: 'Fin de conversación',
        logo: '/media/image/titleMobile.png',
        messages: [[{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: '¿Estás ahí?',
            author: 'Carvin',
            inbound: true,
            duration: 500
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'Haz scroll para conversar',
                author: '',
                skipMessageBlocks: 0
            }]
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Necesitamos tu ayuda',
            author: 'Duncan',
            inbound: true,
            duration: 700
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'Contestar',
                author: 'Tú',
                skipMessageBlocks: 0,
                messageToShow: '¿Es a mi? ¿Qué queréis?'
            }]
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Mira este vídeo y lo entenderás',
            author: 'Duncan',
            inbound: true,
            duration: 2700,
            showMedia: {
                elements: [{
                    type: 'video',
                    src: 'media/video/introHomeMobile.mp4',
                    subtitle: 'Alastair Reid'

                }],
                srcThumbnail: 'media/image/omranth1.jpg',
                mediaId: 1
            },
            messageId: 1
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Estamos intentando descubrir la verdad de muchos de los crímenes de guerra que se cometen diariamente en el mundo',
            author: 'Carvin',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: '¿Podemos contar contigo?',
            author: 'Duncan',
            inbound: true,
            duration: 500
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'Sí… ¿cómo lo hacéis?',
                author: 'Tú',
                skipMessageBlocks: 0
            }, {
                message: '¿Qué puedo hacer yo?',
                author: 'Tú',
                skipMessageBlocks: 3
            }]
        }], [{
            type: 'typing',
            duration: 500,
            inbound: true
        }, {
            message: 'Es muy simple, usamos información que está al alcance de todos. Se conoce como verificación de fuentes abiertas',
            author: 'Duncan',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Imágenes, testimonios, vídeos de testigos sobre el terreno....',
            author: 'Carvin',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Recopilamos todos los datos posibles y los contrastamos',
            author: 'Duncan',
            inbound: true,
            duration: 700
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Puedes, por ejemplo, ayudarnos a comprobar si son reales las imágenes',
            author: 'Carvin',
            inbound: true,
            duration: 1000,
            showMedia: {
                elements: [{
                    type: 'image',
                    src: 'media/image/Night-vs-day.jpg'
                }],
                srcThumbnail: 'media/image/Night-vs-dayth.jpg',
                mediaId: 2
            },
            messageId: 2
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'También puedes geolocalizarlas, para saber a qué lugar del mundo corresponden',
            author: 'Carvin',
            inbound: true,
            duration: 1000,
            showMedia: {
                elements: [{
                    type: 'image',
                    src: 'media/image/Attack-5.jpg'
                }],
                srcThumbnail: 'media/image/Attack-5th.jpg',
                mediaId: 3
            },
            messageId: 3
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'O buscar en Twitter, Facebook, Youtube o cualquier otra red social testigos que nos ayuden a comprobar qué ha pasado',
            author: 'Duncan',
            inbound: true,
            duration: 1000
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'Yo no sé hacer eso',
                author: 'Tú',
                skipMessageBlocks: 0
            }, {
                message: 'Ok, comencemos',
                author: 'Tú',
                skipMessageBlocks: 2
            }]
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Normal, lleva pocos años aplicándose pero no hay que ser ningún experto para poder empezar',
            author: 'Carvin',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Mira este vídeo',
            author: 'Duncan',
            inbound: true,
            duration: 2500,
            showMedia: {
                elements: [{
                    type: 'video',
                    src: 'media/video/finalCaseMobile.mp4',
                    subtitle: 'Alastair Reid'
                }],
                srcThumbnail: 'media/image/trailerth.jpg',
                hoverTitle: 'Cómo investigar en otros idiomas',
                hoverText: 'Alastair Reid, editor de First Draft News, te explica cómo tenemos de actuar si nos enfrentamos a investigaciones en otros alfabetos, como el árabe o el cirílico.',
                mediaId: 4
            },
            messageId: 4
        }], [{
            message: 'Para empezar a investigar accede a este webdoc desde un ordenador o tablet',
            author: 'Carvin',
            inbound: true,
            duration: 2700
        }]],
        trailer: {
            src: 'media/video/trailerMobile.mp4',
            srcSubtitles: 'media/subtitles/trailerMobile.vtt',
            text: 'Mira el trailer'
        }
    },
    About: {
        title: 'El proyecto',
        menu: {
            elem1: {
                name: 'INVESTIGACIONES'
            },
            elem2: {
                name: 'DICCIONARIO'
            },
            elem3: {
                name: 'TUTORIALES'
            }
        },
        dictionary: {
            elems: [{
                letter: 'a',
                words: [{
                    word: 'Alto el fuego',
                    desc: 'Es la detención temporal de una guerra, o de cualquier conflicto armado, en la que los bandos enfrentados acuerdan, mutua o unilateralmente, el cese de las hostilidades. Puede producirse en todo el conflicto o parcialmente en alguna zona afectada por él.'
                }, {
                    word: 'Ataque con gas clorhídrico',
                    desc: 'Un arma que fue utilizada en la Primera Guerra Mundial, y que trístemente ha reaparecido desde 2014 en Siria.  Utilizado frecuentemente contra población civil. Altamente corrosivo e irritante, una simple exposición breve a bajos niveles produce irritación de la garganta, y en grandes dosis provoca la muerte.'
                }]
            }, {
                letter: 'b',
                words: [{
                    word: 'Bellingcat',
                    desc: 'Web de investigación creada "por y para el periodismo ciudadano", que utiliza fuentes abiertas y redes sociales para analizar conflictos de todo tipo que ocurren en el mundo. <a href="https://www.bellingcat.com/" target="_blank">Bellingcat</a> fue fundada en 2014 por Eliot Higgins, después de dos años de investigación en solitario. En ella, un grupo de voluntarios publica estudios exhaustivos que son referentes internacionales para denunciar crímenes y violaciones de los Derechos Humanos.'
                }, {
                    word: 'Bomba de barril',
                    desc: 'Es un tipo de artefacto explosivo artesanal o improvisado (improvised explosive device, IED, por su siglas en inglés), que consiste en barriles llenos de explosivos, con frecuencia armas químicas, y fragmentos metálicos como clavos que se proyectan como metralla. Son lanzados desde helicópteros normalmente y su poca precisión los ha convertido en el tipo de arma más utilizada contra zonas civiles.'
                }, {
                    word: 'BUK',
                    desc: 'El sistema de misiles Buk (en ruso “Бук”) es un sistema de defensa antiaérea, armado con misiles tierra-aire, desarrollado por la Unión Soviética y posteriormente por Rusia. Una docena de países cuentan con BUK en su arsenal. Son capaces de interceptar misiles de crucero, bombas inteligentes, aeronaves y drones.'
                }]
            }, {
                letter: 'c',
                words: [{
                    word: 'Cascos blancos (White Helmets)',
                    desc: 'Conocidos así por que su trabajo se asemeja al de la <a href="https://es.wikipedia.org/wiki/Cascos_Blancos" target="_blank">Comisión de Cascos Blancos</a> creada en Argentina en 1993, es un cuerpo civil de Siria dedicado a la asistencia humanitaria. Conocidos también como <a href="http://syriacivildefense.org/" target="_blank">Defensa Civil Siria</a> (DCS) y الدفاع المدني السوري en árabe, reúne a cerca de 3.000 personas en más de 100 centros repartidos por el país con la única intención de salvar vidas. Han sido candidatos al Nobel de la paz 2016, pese a que el Gobierno de al-Ásad y Rusia les acusan de ser un grupo terrorista.'
                }, {
                    word: 'Citizen Evidence Lab',
                    desc: 'Creado por <a href="https://citizenevidence.org/" target="_blank">Amnistía Internacional</a>, tiene como objetivo apoyar a los investigadores y defensores de los Derechos Humanos aprovechando mejor los nuevos flujos de datos digitales que emanan de las zonas de conflicto y otros puntos críticos del planeta. Por cierto, buscan colaboradores.'
                }, {
                    word: 'Corredor humanitario:',
                    desc: 'Su objetivo es facilitar la distribución de la ayuda humanitaria a civiles durante un conflicto armado, así como el paso de población civil entre zonas de distintos bandos. Los distintos bandos deben comprometerse a respetar las zonas delimitadas y no realizar ataques en ellas.'
                }]
            }, {
                letter: 'e',
                words: [{
                    word: 'Euromaidan',
                    desc: 'Es el nombre de las manifestaciones y disturbios de índole europeísta y nacionalista en Ucrania, que derivaron en la destitución del presidente electo Víktor Yanukóvich la noche del 21 de noviembre de 2013. Fue la semilla del enfrentamiento entre prorrusos y proeuropeos que aún mantienen un conflicto armado por el país.'
                }]
            }, {
                letter: 'f',
                words: [{
                    word: 'Fuentes abiertas',
                    desc: 'Son todas aquellas personas que comparten información sobre cualquier tipo de hechos, y especialmente crímenes, a través de medios de acceso público como las redes sociales. Sus testimonios pueden ser fundamentales para conocer la verdad sobre sucesos a los que los medios convencionales tienen difícil acceso.'
                }, {
                    word: 'First Draft',
                    desc: 'Es una organización dedicada a mejorar las habilidades y estándares en la producción y el intercambio de información on line. Su web <a href="https://es.firstdraftnews.com/" target="_blank">First Draft News</a> está principalmente orientada para que los periodistas adopten las nuevas técnicas de verificación de fuentes abiertas.'
                }, {
                    word: 'Forensic Architecture',
                    desc: 'Agencia de investigación de la Universidad de Londres que realiza proyectos de arquitectura forense. Su trabajo para todo tipo de organizaciones internacionales pro Derechos Humanos trata de reconstruir virtualmente lugares donde esos derechos han sido violados.'
                }]
            }, {
                letter: 'v',
                words: [{
                    word: 'Verificación de fuentes abiertas',
                    desc: 'Es un método de comprobación de información que recurre a información pública accesible en internet para contrastar su veracidad.'
                }]
            }]
        },
        investigations: {
            elems: [{
                title: 'La masacre de Guta',
                desc: 'Más de 1.400 personas murieron y otras 3.000 resultaron heridas en un ataque con armas químicas, realizado el 21 de agosto de 2013 en el barrio de Guta, al sur de Damasco. Desvelar quién fue el responsable de este crimen contra la Humanidad ha sido hasta el momento uno de los trabajos más importantes de Eliot Higgins.',
                subtitle: 'Accede a la investigación',
                links: [{
                    name: 'Bellingcat',
                    link: 'https://www.bellingcat.com/news/mena/2015/08/20/8_21chemicaltrail/'
                }, {
                    name: 'Human Rights Watch',
                    link: 'https://www.hrw.org/sites/default/files/reports/syria_cw0913_web_1.pdf'
                }]
            }, {
                title: 'Crímenes de guerra en Maiduguri (Nigeria)',
                desc: 'La lucha entre el ejército nigeriano y el grupo terrorista Boko Haram por hacerse con el control de la ciudad de MAiduguri derivó en la muerte a sangre fría de cientos de inocentes. En concreto, 640 presos fugados, que gueron capturados inermes, fueron ejecutados extraoficialmente por el ejército. Amnistía Internacional trabajó con vídeos anónimos grabados en el lugar de los hechos para demostrar los hechos.',
                subtitle: 'Lee cómo fue posible demostrarlo',
                links: [{
                    name: 'Amnistía Internacional',
                    link: 'https://www.es.amnesty.org/en-que-estamos/blog/historia/articulo/como-nos-ayudo-la-tecnologia-a-denunciar-los-crimenes-de-guerra-de-nigeria/'
                }]
            }, {
                title: 'Yemen, una población olvidada bajo la guerra',
                desc: 'La guerra de Yemen, pese a sus similitudes con la que se está llevando a cabo en Siria, no ocupa tanto tiempo en los informativos. La lucha comenzó en este país árabe, el más pobre, en 2014. En el conflicto participan diversos actores, tanto nacionales como internacionales, que mantienen a la población civil en una situación de extrema necesidad con sus enfrentamientos.',
                subtitle: 'Ver las verificaciones de Bellingcat',
                links: [{
                    name: 'Crímenes contra los Derechos Humanos en Yemen',
                    link: 'https://www.bellingcat.com/?s=yemen'
                }]
            }, {
                title: 'Saydnaya, en el interior de la cárcel de torturas siria',
                desc: 'La prisión de Saydnaya en Siria es un infierno sobre la tierra. Torturas, condiciones inhumanas y muerte es lo que relatan los que han logrado sobrevivir. Forensic Architecture, en colaboración con Amnistía Internacional, realiza una recreación virtual de la prisión basada en los testimonios de 65 supervivientes.',
                subtitle: 'Ver la recreación:',
                links: [{
                    name: 'Forensic Architecture',
                    link: 'http://www.forensic-architecture.org/case/saydnaya/'
                }]
            }, {
                title: 'Rafah: Viernes negro',
                desc: 'El viernes 1 de agosto de 2014, en pleno alto el fuego, Israel bomardeó indiscriminadamente Rafah, localidad situada al sur de la Franja de Gaza, matando a entre 135 y 200 personas. Un comando del brazo armado de Hamas había tendido una emboscada a soldados israelíes que estaban buscando neutralizar un túnel que conectaba con territorio israelí. En el ataque palestino,murieron dos soldados mientras su jefe, el teniente Hadar Goldin desapareció sin saber si estaba vivo o muerto.Amnistía Internacional y Forensic Architecture llevaron a cabo un informe en el que acusan a Israel de crímenes de guerra.',
                subtitle: 'Ver informe completo',
                links: [{
                    name: 'Amnistía Internacional',
                    link: 'https://blackfriday.amnesty.org/'
                }]
            }]
        },
        tutorials: {
            elems: [{
                title: 'Verificación de imágenes',
                desc: 'Conocer el origen de una imagen y descifrar las pistas que revela para poder saber dónde ha sido tomada puede ser fundamental para una investigación. Descubre cómo hacerlo con estos tutoriales de First Draft News.',
                subtitle: '',
                links: [{
                    name: 'Desafío de Observación',
                    link: 'https://firstdraftnews.com/articulate/obsc/story.html'
                }, {
                    name: 'Verificación con Google Earth',
                    link: 'https://firstdraftnews.com/resource/how-to-verify-images-like-a-pro-with-google-earth/'
                }]
            }, {
                title: 'Geolocalización',
                desc: 'La geolocalización es un paso vital en el proceso de verificación de información. First Draft News ha desarrollado el siguiente ejercicio con el que podrás practicar la navegación por la calle, buscar puntos de referencia, ver imágenes históricas y medir distancias. También puedes agudizar tu olfato con Geoguessr, un adictivo juego que recomienda el Citizen Evidence Lab de Amnistía Internacional.',
                subtitle: '',
                links: [{
                    name: 'Desafío First Draft',
                    link: 'https://firstdraftnews.com/articulate/glch/story.html'
                }, {
                    name: 'Geoguessr',
                    link: 'https://geoguessr.com/'
                }]
            }, {
                title: 'Evaluación de vídeo',
                desc: 'Aprende los fundamentos de la verificación de vídeo de YouTube con esta guía de Citizen Evidence Lab.',
                subtitle: '',
                links: [{
                    name: 'Verificación de vídeo',
                    link: 'http://fluidsurveys.com/surveys/ckoettl/citizen-video-assessment-exercise/'
                }]
            }, {
                title: '¿Cómo encontrar testigos en las redes sociales?',
                desc: 'La búsqueda de noticias en redes sociales es una práctica cada vez más habitual. De hecho, en casos en los que prácticamente no hay medios de comunicación sobre el terreno, la búsqueda de fuentes en redes es fundamental para documentar hechos como las violaciones de Derechos Humanos. First Draft News tiene una completa gama de tutoriales clasificados por redes sociales.',
                subtitle: '',
                links: [{
                    name: 'Facebook',
                    link: 'https://firstdraftnews.com/resource/2845/'
                }, {
                    name: 'Facebook Live',
                    link: 'https://firstdraftnews.com/resource/find-facebook-live-videos-news/'
                }, {
                    name: 'Instagram',
                    link: 'https://firstdraftnews.com/resource/find-newsworthy-pictures-videos-instagram/'
                }, {
                    name: 'Twitter',
                    link: 'https://firstdraftnews.com/resource/how-to-find-tweets-by-location/'
                }]
            }]
        }
    },
    Credits: {
        block1: {
            title: 'CRÉDITOS WEBDOC LAB RTVE.ES',
            elements: {
                elem1: {
                    job: 'Guión',
                    personName: 'César Peña'
                },
                elem2: {
                    job: 'Realización',
                    personName: 'Marcos Martín'
                },
                elem3: {
                    job: 'Desarrollo',
                    personName: 'Lab RTVE.es'
                },
                elem4: {
                    job: 'Diseño',
                    personName: 'Lab RTVE.es'
                },
                elem5: {
                    job: 'Locución',
                    personName: 'Paula Aller'
                },
                elem6: {
                    job: 'Coordinación',
                    personName: 'Miriam Hernanz'
                }
            }
        },
        block2: {
            title: 'CRÉDITOS EN PORTADA  TVE',
            elements: {
                elem1: {
                    job: 'Guión',
                    personName: 'Yolanda Álvarez'
                },
                elem2: {
                    job: 'Realización',
                    personName: 'Marcos Martín'
                },
                elem3: {
                    job: 'Imagen y sonido',
                    personName: 'José Martínez, Alfredo Sánchez-Toledo'
                },
                elem5: {
                    job: 'Montaje',
                    personName: 'Marga Serrano'
                },
                elem6: {
                    job: 'Dirección',
                    personName: 'José Antonio Guardiola'
                }
            }
        },
        block3: {
            title: 'Agradecimientos',
            elem1: {
                name: 'Con Ucrania',
                link: 'https://conucrania.com/'
            }
        },
        footer: {
            title: 'Un proyecto transmedia de',
            elem1: {
                name: 'En Portada',
                link: 'http://www.rtve.es/television/en-portada/',
                icon: 'icon-enportada'
            },
            elem2: {
                name: 'Lab RTVE',
                link: 'http://lab.rtve.es',
                icon: 'icon-logolab'
            }
        },
        name: 'Créditos'
    },
    Case: {
        'case1': {
            title: '¿Quién bombardeó el hogar de Omran?',
            titleBottom: 'Instrucciones del interactivo',
            explanationInteraction: '',
            nameMenu: 'CASO 1',
            imageMenu: '/media/image/menu1.png',
            url: '/quien-bombardeo-hogar-omran/',
            description: 'Descubre quiénes son los responsables de bombardeos a población civil como Omran a través de métodos de investigación de fuentes abiertas realizados por y para ciudadanos. Organizados en torno a <a href="https://www.bellingcat.com/" target="_blank">Bellingcat</a>, web fundada en 2014 por Eliot Higgins, utilizan fundamentalmente testimonios publicados en redes sociales para comprobar hechos en todo el mundo.',
            button: 'Descubre la verdad',
            buttonStart: 'Empezar',
            buttonSkip: 'Saltar intro',
            buttonContinue: 'Comenzar',
            buttonGoInteractive: 'Ir al interactivo',
            background: 'media/image/bg-case1.jpg',
            logoFooter: 'media/image/logoEs.png',
            wordsParallax: ['media/image/word-about.png', 'media/image/word-forget.png', 'media/image/word-here.png', 'media/image/word-playing.png', 'media/image/word-to-win.png'],
            messages: [[{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¡Ey! ¿Habéis visto estas imágenes?',
                author: 'Carvin',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/7cfBmRW3isc?autoplay=1&enablejsapi=1',
                        subtitle: 'Vídeo del rescate'
                    }],
                    srcThumbnail: 'media/image/omranth1.jpg',
                    hoverTitle: 'Vídeo del rescate de Omran',
                    hoverText: 'Tras 5 horas entre los escombros de su casa, Omran Daqneesh es rescatado junto a dos de sus hermanos.',
                    mediaId: 1
                },
                messageId: 1
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Haz scroll para conversar',
                    author: '',
                    skipMessageBlocks: 0
                }]
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Están dando la vuelta al mundo. Pobre niño, qué mirada. Se llama Omran...',
                author: 'Duncan',
                inbound: true,
                duration: 700
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Sabéis dónde ha sido?',
                author: 'Silverman',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'El título en árabe del vídeo en Youtube es "<a href="https://www.youtube.com/watch?v=7cfBmRW3isc" target="_blank">المشاهد الأولية لقصف طائرات حربية يعتقد أنها روسية على حي القاطرجي</a>"',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'No entiendo árabe...',
                author: 'Carvin',
                inbound: true,
                duration: 700
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'No hace falta, esto es lo que recomiendan expertos como Alastair Reid, de <a href="https://firstdraftnews.com/" target="_blank">First Draft News</a>, en ese caso',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/reid1.mp4',
                        srcSubtitles: 'media/subtitles/caso1-reid1.vtt',
                        subtitle: 'Alastair Reid, editor de First Draft News',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/reid1th.jpg',
                    hoverTitle: 'Cómo investigar en otros idiomas',
                    hoverText: 'Alastair Reid, editor de First Draft News, te explica cómo tenemos de actuar si nos enfrentamos a investigaciones en otros alfabetos, como el árabe o el cirílico.',
                    mediaId: 2
                },
                messageId: 2
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Pásalo por Google Translate',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continuar sin traducir',
                    author: 'Tú',
                    skipMessageBlocks: 5
                }]
            }], [{
                message: 'Me lo traduce como "Escenas iniciales de los bombardeos de aviones de combate se cree que son rusos en el barrio de Alqatrgi"',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Y eso dónde está?',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Es un barrio rebelde de Alepo',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Yo tampoco lo conocía ¿Te parece fiable la fuente?',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Déjame ver… el vídeo lo ha colgado AMC "<a href="http://www.amc-sy.net/" target="_blank">Aleppo Media Center</a>" que es un medio local. Además hay en Yotube este otro vídeo de Orient News del rescate del niño: <a href="https://www.youtube.com/watch?v=QIP-jokI3gM" target="_blank">https://www.youtube.com/watch?v=QIP-jokI3gM</a>',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Entonces, ¿vosotros creéis que han sido los rusos? ¿Cómo podemos comprobarlo?',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Hay personas como Reid que ya se dedican a ello, estos son sus consejos',
                author: 'Carvin',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/reid2.mp4',
                        srcSubtitles: 'media/subtitles/caso1-reid2.vtt',
                        subtitle: 'Alastair Reid, editor de First Draft News',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/reid2th.jpg',
                    hoverTitle: '¿Cuáles son los principios de la verificación?',
                    hoverText: 'Como en cualquier investigación periodística, cuando como ciudadanos nos enfrentamos a una investigación debemos intentar responder las 5 w’s.',
                    mediaId: 3
                },
                messageId: 3
            }], [{
                message: 'He encontrado en el perfil oficial de Facebook del Ejército Ruso este comunicado',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D1786927808216634%26id%3D1492252324350852&width=500',
                        subtitle: 'Comunicado oficial',
                        style: { 'min-height': '15vw' }
                    }],
                    srcThumbnail: 'media/image/comunicadoomranth.jpg',
                    hoverTitle: 'Comunicado oficial de la Defensa rusa',
                    hoverText: 'Una publicación en el perfil de Facebook del Ministerio de Defensa ruso afirma que Rusia no tiene nada que ver con el bombardeo del barrio de Alepo, ya que se encuentra entre dos corredores humanitarios.',
                    mediaId: 4
                },
                messageId: 4
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Al parecer los rusos defienden que no han sido ellos, porque el lugar del bombardeo se encuentra entre dos de los seis corredores humanitarios',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Los habilitaron para que los civiles de la zona rebelde pudieran abandonarla pacíficamente, y aseguran que ellos no atacan esos corredores',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Y los suelen respetar, o son una trampa?',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Busquemos pruebas',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continuemos investigando',
                    author: 'Tú',
                    skipMessageBlocks: 6
                }]
            }], [{
                message: 'Según los medios rusos la gente está abandonando la zona rebelde sin problemas',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/pantallazort.jpg',
                        subtitle: 'La televisión rusa RT hace públicas unas imágenes en las que muestra a un grupo de personas que, según su información, están abandonando pacíficamente la zona rebelde.'
                    }],
                    srcThumbnail: 'media/image/pantallazortth.jpg',
                    hoverTitle: 'RT muestra pruebas del respeto a los corredores humanitarios',
                    hoverText: 'La televisión Rusia Today hace públicas unas imágenes en las que muestra a un grupo de personas que, según su información, están abandonando pacíficamente la zona rebelde.',
                    mediaId: 5
                },
                messageId: 5
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'No te fíes',
                author: 'Carvin',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'En Youtube circula un vídeo de Qasioun News Agency en el que el mismo señor que aparece con su hija en brazos de fondo en el vídeo de RT dice que estaba haciendo cola para comprar el pan y no abandonando zona rebelde.',
                author: 'Carvin',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Vamos, la web de <a href="https://www.bellingcat.com/news/mena/2016/09/01/fact-checking-russias-claim-didnt-bomb-5-year-old-syria/" target="_blank">Bellingcat</a> ya lo ha comprobado',
                author: 'Carvin',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/-_D1NEvZZNg?autoplay=1&enablejsapi=1',
                        subtitle: 'El testimonio de una de las personas citadas por RT desmiente que estuviese utilizando un corredor humanitario'
                    }],
                    srcThumbnail: 'media/image/testimonioth.jpg',
                    hoverTitle: 'Los testigos hablan',
                    hoverText: 'Uno de los ciudadanos que según la RT estaban utilizando el corredor humanitario explica que las imágenes fueron sacadas de contexto.',
                    mediaId: 6
                },
                messageId: 6
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'También dice que él no piensa abandonar la zona rebelde...',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Ok. Descartamos esta pista',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Qué más sabemos?',
                author: 'Carvin',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Centrémonos en si había o no corredores humanitarios',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'El portavoz del ejército ruso dio una <a href="http://syria.mil.ru/en/index/syria/news/more.htm?id=12091371@egNews" target="_blank">rueda de prensa</a> meses antes detallando su ubicación',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/corredoresrusos.jpg',
                        subtitle: 'El Jefe de Operaciones del Estado Mayor ruso, Sergei Rudskoy, expone la localización de los corredores humanitarios ante los medios'
                    }],
                    srcThumbnail: 'media/image/corredoresrusosth.jpg',
                    hoverTitle: 'Localización de los corredores humanitarios, según Rusia',
                    hoverText: 'El Jefe de Operaciones del Estado Mayor ruso, Sergei Rudskoy, expone la localización de los corredores humanitarios ante los medios',
                    mediaId: 7
                },
                messageId: 7
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'A lo mejor podríamos comprobar si el bombardeo fue cerca de uno de ellos.',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Mira, este es el mapa que se reparte sobre el terreno, en Alepo, sobre los corredores.',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Lo ha colgado <a href="https://www.facebook.com/syrian.reporters/photos/a.575752362470341.1073741825.254488777930036/1125715137474058/?type=3&theater" target="_blank">Syrian Reporters en su Facebook</a>.  No coinciden el número de corredores (en este hay menos que en el mapa ruso), ni su ubicación',
                author: 'Carvin',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/corredoressirios.jpg',
                        subtitle: 'Sirian Reporters muestra en Facebook la información sobre los corredores humanitarios'
                    }],
                    srcThumbnail: 'media/image/corredoressiriosth.jpg',
                    hoverTitle: 'Información sobre corredores humanitarios que se reparte sobre el terreno',
                    hoverText: 'Una imagen publicada en Facebook por Sirian Reporters muestra que, sobre el terreno, la información sobre los corredores humanitarios no coincide con las ubicaciones que afirmaba Rusia.',
                    mediaId: 8
                },
                messageId: 8
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Veámoslo en Google Maps',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continuemos',
                    author: 'Tú',
                    skipMessageBlocks: 2
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Así quedaría si lo pasamos a un mapa…',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.google.com/maps/d/u/1/embed?mid=1-oqF7_xENUquE2DoQmvZcNKr1bE',
                        subtitle: 'Superposición de mapas de los corredores humanitarios en Alepo.'
                    }],
                    srcThumbnail: 'media/image/Aleppo-corridorsth.jpg',
                    hoverTitle: 'Comparativa de las ubicaciones',
                    hoverText: 'Así quedarían los mapas de los corredores superpuestos. Las informaciones de la Defensa Rusa y la imagen compartida por Syrian Reporters no coincide.',
                    mediaId: 9
                },
                messageId: 9
            }], [{
                type: 'typing',
                duration: 500,
                inbound: true
            }, {
                message: 'Es cierto, no coincide con el mapa oficial ruso...',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Entonces, ¿dónde estaba la casa de Omran?',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }]],
            parallaxContent: [{
                type: 'image',
                velocity: '0.65',
                img: 'lineCase1.png'
            }, {
                type: 'string',
                velocity: '0.5',
                txt: 'El caso'
            }, {
                type: 'string',
                velocity: '0.20',
                txt: 'omran'
            }, {
                type: 'image',
                velocity: '0.30',
                img: 'lineCase1.png'
            }, {
                type: 'string',
                velocity: '0.4',
                txt: '<h1>¿Quién bombardeó el hogar de Omran?</h1>'
            }, {
                type: 'image',
                velocity: '0.3',
                img: 'rectangleCase1.png'
            }],
            interaction: {
                instructions1: {
                    title: 'Pasa el ratón por las dos fotografías para aprender cómo se verifican imágenes'
                },
                explanation: {
                    view1: {
                        day: "Fíjate en la forma del tronco y compara las dos imágenes para ver si coinciden.",
                        night: "La forma y la disposición de los distintos elementos pueden ser un buen referente para comprobar la ubicación en el mapa de una imagen."
                    },
                    view2: {
                        day: "La distancia con otros elementos coincidentes, como el árbol, pueden ayudar en la comprobación.",
                        night: "Otros elementos como formas de las ventanas o locales comerciales de los edificios pueden ser pistas relevantes."
                    },
                    view3: {
                        day: "La posición del toldo, la ventana y el árbol indican que ambas imágenes pertenecen al lugar del bombardeo.",
                        night: "Las condiciones de luz y el lugar desde el que está tomada la imagen pueden dificultar la verificación."
                    }
                },
                instructions2: {
                    title: 'Compara las imágenes con la fotografía satélite',
                    subtitle: 'Utiliza los fotogramas extraídos de vídeos del lugar del ataque para localizar su posición en el mapa'
                },
                photos: {
                    title: 'Selecciona la pista y rastreala en el mapa haciendo click',
                    copyright: 'Digital Globe/NextView',
                    correctTitle: 'Localización Correcta',
                    wrongTitle: 'Sigue buscando',
                    selectClue: 'Selecciona una de las tres pistas de la derecha',
                    closeClue: 'Cierra la imagen de la pista para comenzar',
                    pista: 'Pistas:',
                    src: '/media/image/interactionCase1.jpg',
                    photo1: {
                        photoSrc: '/media/image/intCase1-photo1.jpg',
                        thumbSrc: '/media/image/intCase1-thumb1.png',
                        correctText: "La forma del edificio y su posición con respecto a los del entorno certifican que es el lugar que buscábamos.",
                        wrongText: "Intenta localizar un edificio más alto que los de su entorno. Utiliza objetos o referentes que le rodéan para dar con la ubicación."
                    },
                    photo2: {
                        photoSrc: '/media/image/intCase1-photo2.jpg',
                        thumbSrc: '/media/image/intCase1-thumb2.png',
                        correctText: "Pese a la escasa perspectiva de la imagen satélite, has localizado los dos edificios.",
                        wrongText: "Localiza los dos edificios paralelos que se ven al fondo de la imágen de pista. Usa como referencia la distancia entre ellos. "
                    },
                    photo3: {
                        photoSrc: '/media/image/intCase1-photo3.jpg',
                        thumbSrc: '/media/image/intCase1-thumb3.png',
                        correctText: "La localización de los tres puntos certifica que el lugar en el que fue rescatado Omran es el barrio rebelde de Alqatrgi.",
                        wrongText: "Busca un cúmulo de escombros o descampado en la imagen satélite."
                    }
                }
            },
            conclusion: {
                title: 'Conclusión',
                text: ['Aunque no es posible demostrar la autoría del bombardeo, sí puede afirmarse que se realizó mediante un ataque aéreo sobre zona rebelde, tal y como afirma la investigación desarrollada por Bellingcat.', 'Los argumentos del Ministerio de Defensa ruso respecto a los corredores humanitarios no coinciden con la información facilitada sobre el terreno, ni los supuestos testigos usados por los medios rusos lo son realmente.', 'Las sospechas sobre un ataque rebelde en su propia zona pueden ser descartadas, ya que no poseen el armamento necesario para causar ese tipo de destrucción.', 'A finales de 2016 la ofensiva gubernamental acabó con la resistencia rebelde y con el bombardeo diario en Alepo, una ciudad destruida de donde miles de civiles han sido evacuados.', 'Todas las conversaciones de esta experiencia son una recreación del exhaustivo análisis de fuentes abiertas realizado por Bellingcat.'],
                verification: {
                    text: 'Investigación de Bellingcat',
                    link: 'https://www.bellingcat.com/news/mena/2016/09/01/fact-checking-russias-claim-didnt-bomb-5-year-old-syria/'
                },
                nextStep: {
                    text: 'Próximo Caso',
                    link: '/quien-derribo-mh17/'
                },
                icon: 'icon-bomb'
            },
            icon: 'icon-plane',
            urlVideo: '/media/video/introCase1.mp4',
            urlSubtitles: '/media/subtitles/caso1-intro-es.vtt'
        },
        'case2': {
            title: '¿Quién derribó el MH17?',
            titleBottom: 'Busca una evidencia de que el camión ha sido atacado por un misil aéreo',
            explanationInteraction: 'Selecciona los tuits para dibujar en el mapa el recorrido del camión',
            nameMenu: 'CASO 2',
            imageMenu: '/media/image/menu2.png',
            url: '/quien-derribo-mh17/',
            description: 'Investiga las pruebas sobre el ataque al avión de Malaysia Airlines para saber quién está detrás.',
            button: 'Comenzar investigación',
            buttonStart: 'Empezar',
            buttonSkip: 'Saltar intro',
            buttonContinue: 'Continuar',
            buttonGoInteractive: 'Ir al interactivo',
            background: 'media/image/bg-case2.jpg',
            logoFooter: 'media/image/logoEs.png',
            wordsParallax: ['media/image/word-about.png', 'media/image/word-forget.png', 'media/image/word-here.png', 'media/image/word-playing.png', 'media/image/word-to-win.png'],
            messages: [[{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Se ha estrellado un avión con casi 300 personas en Ucrania...',
                author: 'Lanchlan',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Lo he visto. Dicen que en él viajaban algunos de los más prestigiosos investigadores sobre el VIH. Las imágenes son terribles',
                author: 'Elcho',
                inbound: true,
                duration: 700,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/3244662.jpg',
                        subtitle: 'Los restos del avión quedaron esparcidos por el este de Ucrania en un área de 50 kilómetros cuadrados.'
                    }, {
                        type: 'image',
                        src: 'media/image/7005205.jpg',
                        subtitle: 'Sin embargo, el grueso de los restos del avión se localizan en el pueblo de Grabovo.'
                    }, {
                        type: 'image',
                        src: 'media/image/7009893.jpg',
                        subtitle: 'Vecinos de la localidad de Torez también resultaron heridos, ya que trozos del avión dañaron algunas casas.'
                    }, {
                        type: 'image',
                        src: 'media/image/7011359.jpg',
                        subtitle: 'Algunos medios informan del robo de tarjetas de crédito de las víctimas.'
                    }, {
                        type: 'image',
                        src: 'media/image/7012588.jpg',
                        subtitle: 'Entre el 14 y el 17 de julio un total de 61 aerolíneas de 32 países operaban en el espacio aéreo del este de Ucrania.'
                    }, {
                        type: 'image',
                        src: 'media/image/7270990.jpg',
                        subtitle: 'La investigación oficial corre a cargo de siete países (Holanda, Ucrania, Malasia, Estados Unidos, Reino Unido, Australia y Rusia).'
                    }],
                    srcThumbnail: 'media/image/fotogaleriath.jpg',
                    hoverTitle: 'Fotogalería del desastre',
                    hoverText: 'Las imágenes de los restos del avión en la zona ucraniana de Grabovo muestran con crudeza el suceso.',
                    mediaId: 1
                },
                messageId: 1
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¡Madre mía! ¿Y qué ha pasado? ¿Un fallo humano o técnico?',
                author: 'Fraser',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'No está claro, pero <a href="http://www.rtve.es/alacarta/videos/telediario/vuelo-mh17-fue-derribado-ucrania-impacto-externo-gran-numero-objetos/2747457/" target="_blank">hay sospechas de un ataque</a>',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Terrorista?',
                author: 'Lanchlan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'No exactamente, ha caído al sobrevolar la zona de Ucrania que está en guerra entre el ejército ucraniano y los prorrusos',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }, {
                message: 'Dicen que pueden haberlo confundido con un avión militar',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Pero qué bando ha sido?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Comprobémoslo',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Pasar al siguiente caso',
                    author: 'Tú',
                    skipMessageBlocks: 0,
                    link: '/quien-destruyo-convoy-humanitario/'
                }]
            }], [{
                message: 'El gobierno de Kiev acusa a los prorrusos, que controlan la zona donde ha caído el avión, pero no tienen pruebas',
                author: 'Lanchlan',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Y los paramilitares y Rusia qué dicen?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                message: 'Que ha sido Kiev, en una maniobra para culparles ante la opinión pública',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/tdMH17.mp4',
                        subtitle: 'Telediario TVE. 17 de noviembre de 2014. Rusia difunde imágenes del supuesto ataque al avión de Malaysia Airlines'
                    }],
                    srcThumbnail: 'media/image/ucraniatdth.jpg',
                    hoverTitle: 'Cruce de acusaciones',
                    hoverText: 'Unas imágenes tomadas supuestamente en el momento del derribo del avión de Malaysia Airlines demostrarían que fue atacado por un avión militar.',
                    mediaId: 2
                },
                messageId: 2
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Cómo podemos comprobarlo?',
                author: 'Fraser',
                inbound: true,
                duration: 500
            }], [{
                message: 'Identifiquemos el tipo de armamento capaz de derribar un avión ¿Se sabe a qué altitud volaba?',
                author: 'Lanchlan',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Los registros oficiales dicen que por encima de los 10.000 metros, la altitud obligatoria en zona de conflicto',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                message: '¿Alguna idea de un misil que alcance esa altura?',
                author: 'Fraser',
                inbound: true,
                duration: 500
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Comprobemos el tipo de misil',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continuemos investigando',
                    author: 'Tú',
                    skipMessageBlocks: 5
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Los medios apuntan que ha sido este tipo de arma el que se ha utilizado. Mira, este vídeo lo explica',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/buk.mp4',
                        srcSubtitles: 'media/subtitles/caso2-buk.vtt',
                        subtitle: 'Informe Semanal de TVE explica qué son los sistemas antiaéreos BUK. 26 de julio de 2014.',
                        subtitleOn: false
                    }],
                    srcThumbnail: 'media/image/bukth.jpg',
                    hoverTitle: 'Así son los misiles BUK',
                    hoverText: 'Exceptuando a Rusia, prácticamente hay unanimidad internacional acerca del arma que ha derribado el avión.',
                    mediaId: 3
                },
                messageId: 3
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Y quién tiene ese tipo de misil?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Los ucranianos tienen misiles <a href="https://es.wikipedia.org/wiki/Misil_Buk" target="_blank">BUK</a>, aunque un modelo algo obsoleto.',
                author: 'Lachlan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Y Rusia tiene BUKs?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Rusia tiene uno de los mayores arsenales del mundo, y de los más actualizados… De hecho son ellos los que están armando a los independentistas',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Parece que por aquí estamos atascados ¿Cómo podemos avanzar?',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Uno de los gurús de la verificación, Eliot Higgins, fundador de <a href="https://www.bellingcat.com/" target="_blank">Bellingcat</a>, te recomienda esto si estás empezando una investigación',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/eliot1.mp4',
                        srcSubtitles: 'media/subtitles/caso2-higgins.vtt',
                        srcPoster: 'media/image/reid1.jpg',
                        subtitle: 'Eliot Higgins, fundador de Bellingcat',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/eliot1th.jpg',
                    hoverTitle: '¿Por dónde empezar una investigación?',
                    hoverText: 'Eliot Higgins, fundador de Bellingcat, te explica cómo comenzar a buscar información sobre un caso.',
                    mediaId: 4
                },
                messageId: 4
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Voy a buscar en <a href="https://twitter.com/search?q=%23MH17&src=tyah" target="_blank">Twitter</a> a ver qué se dice',
                author: 'Lachlan',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Busquemos en Twitter',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Sigamos avanzando',
                    author: 'Tú',
                    skipMessageBlocks: 3
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Estos son algunos de los tuits publicados en la zona del ataque',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'twitter',
                        src: '781125242416721924',
                        subtitle: 'Esto es contenido del primer elemento'
                    }, {
                        type: 'twitter',
                        src: '489807649509478400',
                        subtitle: 'Segundo elemento'
                    }, {
                        type: 'twitter',
                        src: '781116583825506306',
                        subtitle: 'Tercer elemento'
                    }, {
                        type: 'twitter',
                        src: '490646489484374017',
                        subtitle: 'Tercer elemento'
                    }, {
                        type: 'twitter',
                        src: '490645773638307840',
                        subtitle: 'Tercer elemento'
                    }],
                    srcThumbnail: 'media/image/tuitth.jpg',
                    hoverTitle: '¿Qué dicen las redes?',
                    hoverText: 'Las principales redes sociales (Youtube, Facebook, Twitter en todo el mundo, o VKontakte en Rusia) son un recurso habitual para los testigos de todo tipo de sucesos.',
                    mediaId: 5
                },
                messageId: 5
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'En algunos puede verse el rastro de un misil en el cielo...',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Sí, y en otros muchos aparece un camión cargando un tanque que parece un BUK',
                author: 'Lachlan',
                inbound: true,
                duration: 1000
            }], [{
                message: 'Según los investigadores de Dutch-led Joint Investigation Team (<a href="https://www.politie.nl/themas/flight-mh17-2.html" target="_blank">JIT</a>) el rastro de humo ha sido visto en la zona de Pervomaysk, en el noreste de Ucrania',
                author: 'Lachlan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d206298.71937171486!2d38.414511344577505!3d48.60790908938558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40e003b178e14c25%3A0xed72d30bea2efce0!2sPervomaisk%2C+Lugansk%2C+Ucrania!5e1!3m2!1ses!2ses!4v1479989575805',
                        subtitle: 'Lugar estimado del lanzamiento del misil'
                    }],
                    srcThumbnail: 'media/image/pervomayskth.jpg',
                    hoverTitle: 'Localización del BUK en el momento del ataque',
                    hoverText: 'Las pistas sobre la localización de la batería tierra-aire que ha abatido el MH17 lo sitúan cerca de la localidad de Pervomaysk.',
                    mediaId: 6
                },
                messageId: 6
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Es posible saber si ese BUK que se ve en las fotos estaba por la zona?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Podemos ver el recorrido que ha realizado en función de dónde se han publicado esos tuits',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }]],
            parallaxContent: [{
                type: 'image',
                velocity: '0.65',
                img: 'lineCase2.png'
            }, {
                type: 'string',
                velocity: '0.5',
                txt: 'El caso'
            }, {
                type: 'string',
                velocity: '0.20',
                txt: 'MH 17'
            }, {
                type: 'image',
                velocity: '0.30',
                img: 'lineCase2.png'
            }, {
                type: 'string',
                velocity: '0.4',
                txt: '<h1>¿Quién derribó el avión sobre Ucrania?</h1>'
            }, {
                type: 'image',
                velocity: '0.3',
                img: 'rectangleCase2.png'
            }],
            interaction: {
                instructions: {
                    title: 'Busca los tuits que estén relacionados con el traslado del BUK para comprobar su ubicación',
                    topText: 'Selecciona los tuits que contienen información crucial relacionada con el BUK',
                    bottomText: 'El mapa muestra el lugar en el que fue visto el BUK y señala su recorrido',
                    originText: 'Un terreno cercano a Pervomaysk, al noroeste de Donesck, es el señalado por el JIT como lugar del lanzamiento del misil',
                    destinationText: 'El vuelo MH17 cayó en este punto, cerca de la localidad de Grabovo'
                },
                tweetsSrc: ['/media/image/1 ES.png', '/media/image/2 ES.png', '/media/image/3 ES.png', '/media/image/4 ES.png', '/media/image/5 ES.png', '/media/image/6 ES.png', '/media/image/7 ES.png', '/media/image/8 ES.png', '/media/image/9 ES.png', '/media/image/10 ES.png'],
                wrongText: 'Sigue buscando<br>Este tuit no fue publicado en la zona y no está relacionado con el transporte del BUK.'
            },
            conclusion: {
                title: 'Conclusión',
                text: ['Esta verificación certifica que el avión de pasajeros MH17 fue derribado por un misil tierra-aire.', 'Se descarta la hipótesis de una avería o una explosión debido a un ataque terrorista. También queda descartada la opción de un ataque aéreo.', 'Además, podemos afirmar que un tanque BUK del ejército ruso viajó el día del ataque desde la ciudad rebelde de Donesck hasta la zona desde la que fue lanzado el misil.', 'Estas evidencias apuntan a que la muerte de 298 civiles se debió a un ataque de los rebeldes prorrusos con armamento del Ejército Ruso, sin que se pueda demostrar si fue intencionado o no.', 'Esta verificación está inspirada en las conclusiones del Joint International Criminal Investigation y el trabajo previo de Bellingcat.'],
                verification: {
                    text: 'Informe del JIT',
                    link: 'https://www.om.nl/onderwerpen/mh17-vliegramp/presentaties/presentation-joint/'
                },
                nextStep: {
                    text: 'Próximo Caso',
                    link: '/quien-destruyo-convoy-humanitario/'
                },
                icon: 'icon-plane'
            },
            icon: 'icon-plane',
            urlVideo: '/media/video/introCase2.mp4',
            urlSubtitles: '/media/subtitles/caso2-intro-es.vtt'
        },
        'case3': {
            title: '¿Quién destruyó el convoy de Urum Al Kubra?',
            titleBottom: 'Localiza las evidencias del ataque en la imagen',
            explanationInteraction: '',
            nameMenu: 'CASO 3',
            imageMenu: '/media/image/menu3.jpg',
            url: '/quien-destruyo-convoy-humanitario/',
            description: 'Averigua si el ataque al convoy humanitario se produjo de forma premeditada y qué tipo de ataque destruyó la ayuda humanitaria.',
            button: 'Comenzar investigación',
            buttonStart: 'Empezar',
            buttonSkip: 'Saltar intro',
            buttonContinue: 'Continuar',
            buttonGoInteractive: 'Ir al interactivo',
            background: 'media/image/bg-case2.jpg',
            logoFooter: 'media/image/logoEs.png',
            wordsParallax: ['media/image/word-about.png', 'media/image/word-forget.png', 'media/image/word-here.png', 'media/image/word-playing.png', 'media/image/word-to-win.png'],
            messages: [[{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'La ONU ha suspendido el envío de ayuda humanitaria a Siria',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Cómo? ¡Eso es imposible! Miles de personas dependen de esa ayuda para subsistir',
                author: 'Luzader',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Qué ha pasado?',
                author: 'Nickerson',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Al parecer han bombardeado un convoy de la Cruz Roja que estaba preparado para repartir alimentos, medicinas y mantas',
                author: 'Grant',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/tdConvoy.mp4',
                        subtitle: 'Telediario TVE, 20 de septiembre 2016. La ONU paraliza sus actividades humanitarias en Siria. '
                    }],
                    srcThumbnail: 'media/image/onuconvoyth.jpg',
                    hoverTitle: 'La ONU suspende la ayuda humanitaria',
                    hoverText: 'El ataque al convoy de ACNUR y Cruz Roja provoca el anuncio por parte de las Naciones Unidas, de la cancelación de las operaciones humanitarias en Siria por la falta de seguridad.',
                    mediaId: 1
                },
                messageId: 1
            }], [{
                message: 'Dicen que suspenden las operaciones por la inseguridad en la zona',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Quién creéis que ha sido? Normalmente la ubicación de la ayuda humanitaria suele ser pública para que no ocurran estas cosas',
                author: 'Nickerson',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Habría que confirmar si su posición era conocida por los ejércitos que luchan por el control de Alepo...',
                author: 'Luzader',
                inbound: true,
                duration: 500
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Veamos si hay declaraciones',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Avancemos en la investigación',
                    author: 'Tú',
                    skipMessageBlocks: 5
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Desde la ONU confirman que sabían donde se encontraba el convoy',
                author: 'Luzader',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'twitter',
                        src: '778036930567176196',
                        subtitle: "Declaraciones de Stephen O'Brien"
                    }],
                    srcThumbnail: 'media/image/unchiefth.jpg',
                    hoverTitle: 'Declaraciones de la ONU',
                    hoverText: 'El representante en Asuntos Humanitarios de la ONU Stephen O’Brien afirma en Twitter que la posición del convoy era pública.',
                    mediaId: 2
                },
                messageId: 2
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Y Rusia qué dice?',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Según el canal de TV ruso RT, el portavoz del Ministerio de Defensa, Igor Konashenkov, ha afirmado que “<a href="https://www.rt.com/news/359990-russia-denies-aleppo-strike/" target="_blank">el convoy había alcanzado con éxito su objetivo</a>”, por lo que se deduce que el ejército ruso conocía su ubicación...',
                author: 'Nickerson',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.rt.com/news/359990-russia-denies-aleppo-strike/video/',
                        subtitle: 'Noticia publicada por RT el 20 de septiembre de 2016'
                    }],
                    srcThumbnail: 'media/image/russiadeniesth.jpg',
                    hoverTitle: 'Rusia niega haber bombardeado el convoy',
                    hoverText: 'La cadena RT recoge las declaraciones del portavoz del Ministerio de Defensa ruso, Igor Konashenkov, que niega cualquier intervención de Siria o Rusia en el ataque.',
                    mediaId: 3
                },
                messageId: 3
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Todos sabían dónde estaba el convoy, pero nadie se responsabiliza del ataque...',
                author: 'Nickerson',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Vaya si lo sabían... Hay hasta imágenes en Youtube de la monitorización rusa del convoy mediante un dron',
                author: 'Luzader',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/egwLxk-ypKk?autoplay=1&enablejsapi=1',
                        subtitle: 'Imágenes del trayecto del convoy monitorizadas con un dron por Rusia'
                    }],
                    srcThumbnail: 'media/image/dronth.jpg',
                    hoverTitle: 'Un dron ruso controla el convoy',
                    hoverText: 'Rusia tiene imágenes del convoy humanitario grabadas por un dron utilizado para monitorizar el alto el fuego en Alepo, que puede verse en Youtube.',
                    mediaId: 4
                },
                messageId: 4
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Vayamos por partes: La ONU señala a Al Assad y Rusia',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Por su parte, los rusos dicen que ha sido Al Nusra, la filial de Al Qaeda en la zona',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: '¿Pueden haber sido los yihadistas?',
                author: 'Luzader',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'No sé yo… Normalmente suelen reclamar la autoría de este tipo de ataques cuando lo realizan',
                author: 'Grant',
                inbound: true,
                duration: 500
            }, {
                message: 'Y de momento no lo han hecho',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Qué impotencia ¿Cómo podemos saber quién ha sido?',
                author: 'Nickerson',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Podemos empezar verificando la información disponible en internet sobre el tema. Primero identificar, y luego verificar',
                author: 'Luzader',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Eso es lo que siempre dice Eliot Higgins, fundador de <a href="https://www.bellingcat.com/" target="_blank">Bellingcat</a>, sobre su trabajo',
                author: 'Grant',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/higgins1.mp4',
                        srcSubtitles: 'media/subtitles/caso3-higgins.vtt',
                        subtitle: 'Eliot Higgins, fundador de Bellingcat',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/higgins1th.jpg',
                    hoverTitle: 'Las herramientas de la verificación',
                    hoverText: 'Eliot Higgins, fundador de Bellingcat, nos da las claves fundamentales para llevar a cabo procesos de verificación.',
                    mediaId: 5
                },
                messageId: 5
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Empecemos por el tipo de armamento empleado. Al Nusra no tiene aviones bombarderos, por ejemplo…',
                author: 'Luzader',
                inbound: true,
                duration: 500
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Comprobemos armamento',
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continuemos',
                    author: 'Tú',
                    skipMessageBlocks: 2
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Creo que hay algún vídeo en <a href="https://www.youtube.com/results?search_query=WFP+trucks+attack+syria" target="_blank">Youtube</a> del ataque',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Sí, he encontrado uno. Este testigo, miembro de los Cascos Blancos, cuenta que varios helicópteros y aviones sobrevolaron la zona antes y durante el ataque',
                author: 'Luzader',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/K4G5kNeTClQ?autoplay=1&enablejsapi=1',
                        subtitle: 'Un Casco Blanco cuenta cómo ha ocurrido el bombardeo'
                    }],
                    srcThumbnail: 'media/image/cascoth.jpg',
                    hoverTitle: 'Las imágenes del ataque',
                    hoverText: 'Un Casco Blanco de la Defensa Civil Siria explica sobre el terreno los daños causados y qué tipo de ataque ha sido',
                    mediaId: 6
                },
                messageId: 6
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'En la información de la <a href="https://www.rt.com/news/359990-russia-denies-aleppo-strike/" target="_blank">RT</a> comentaban que el portavoz del ejército ruso afirmaba, textualmente: ',
                author: 'Nickerson',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/traduccion.jpg',
                        subtitle: 'Declaraciones de Igor Konashenkov, portavoz del Ejército ruso.'
                    }],
                    srcThumbnail: 'media/image/traduccionth.jpg',
                    hoverTitle: 'Rusia desmiente el ataque aéreo',
                    hoverText: 'El Ejército ruso ha realizado unas declaraciones en las que afirma que las imágenes sobre el terreno certifican que el ataque fue terrestre.',
                    mediaId: 7
                },
                messageId: 7
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Eso es posible saberlo comprobando los vídeos del ataque',
                author: 'Grant',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Podemos buscar los fotogramas en los que se vean los daños en los vehículos y edificios y de ahí dilucidar qué tipo de arma se usó',
                author: 'Nickerson',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'De acuerdo, os paso algunos consejos para encontrar información relevante',
                author: 'Luzader',
                inbound: true,
                duration: 500
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Son de Alastair Reid, director de <a href="https://firstdraftnews.com/" target="_blank">First Draft</a>',
                author: 'Luzader',
                inbound: true,
                duration: 500,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/alastair1.mp4',
                        srcSubtitles: 'media/subtitles/caso3-reid.vtt',
                        subtitle: 'Alastair Reid, editor de First Draft News',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/alastair1th.jpg',
                    hoverTitle: 'Cómo comprobar datos básicos de imágenes',
                    hoverText: 'Alastair Reid, de First Draft News, explica cuáles son los puntos básicos para comprobar si una imagen es falsa en la red.',
                    mediaId: 8
                },
                messageId: 8
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Ok, veamos qué encontramos',
                author: 'Nickerson',
                inbound: true,
                duration: 500
            }]],
            parallaxContent: [{
                type: 'image',
                velocity: '0.65',
                img: 'lineCase3.png'
            }, {
                type: 'string',
                velocity: '0.5',
                txt: 'El caso'
            }, {
                type: 'string',
                velocity: '0.20',
                txt: 'Convoy'
            }, {
                type: 'image',
                velocity: '0.30',
                img: 'lineCase3.png'
            }, {
                type: 'string',
                velocity: '0.4',
                txt: '<h1>¿Quién atacó el convoy humanitario?</h1>'
            }, {
                type: 'image',
                velocity: '0.3',
                img: 'rectangleCase3.png'
            }],
            interaction: {
                instructions: 'Busca en las imágenes del convoy evidencias del tipo de ataque sufrido.',
                photo1: {
                    title: 'Las bombas aéreas pueden causar graves daños en vehículos',
                    subtitle: 'Busca señales de que el camión ha sido atacado por un misil',
                    resolution: 'La imagen muestra cláramente como la cabina del camión ha sido destruida.',
                    copyright: 'Imagen: AMP'
                },
                photo2: {
                    title: 'Los ataques aéreos lanzan misiles que al explotar expulsan metralla que genera graves daños.',
                    subtitle: 'Busca en el vehículo al menos tres muestras de impactos de metralla de misiles.',
                    resolution: 'Los agujeros en la carrocería no suele ser resultado de un incendio, sino de un ataque.',
                    copyright: 'Imagen: وكالة ثقة.P'
                },
                photo3: {
                    title: 'Los misiles lanzados desde el aire pueden crear daños irreparables en infraestructuras.',
                    subtitle: 'Señala dos puntos del edificio en los que se han producido las principales fracturas',
                    resolution: 'La forma en la que se ha derrumbado el edificio evidencia que ha sufrido un ataque desde el aire.',
                    copyright: 'Imagen: وكالة ثقة.'
                },
                wrongText: 'Sigue buscando <br>Esta no es una prueba del ataque'
            },
            conclusion: {
                title: 'Conclusión',
                text: ['Con esta investigación podemos concluir que el daño provocado en la zona demuestra que el convoy fue atacado mediante un ataque aéreo, tal y como refleja el exhaustivo informe publicado por Bellingcat.', 'Tanto la ONU como el Ministerio de Defensa ruso han confirmado conocer el emplazamiento del convoy antes del ataque.', 'Los testimonios de los testigos refuerzan la tesis de un ataque aéreo con bombas de barril tuvo lugar el 19 de septiembre de 2016 contra ayuda humanitaria destinada a la población civil de la zona rebelde de Alepo, Siria.', 'Un día después un convoy ruso con ayuda llegó a la zona controlada por el ejército sirio.', 'Aunque los procesos de verificación con fuentes abiertas se aplican a todo tipo de crímenes en todo el mundo, los tres casos de este webdoc apuntan a la autoría de graves actos contra la población civil del Ejército ruso y sus aliados. También evidencian su uso de la posverdad a la hora de justificar hechos tan reprobables como los aquí documentados.'],
                verification: {
                    text: 'Análisis de Bellingcat',
                    link: 'https://www.bellingcat.com/news/mena/2016/09/21/aleppo-un-aid-analysis/'
                },
                nextStep: {
                    text: 'Ver video',
                    link: '/quien-hace-estas-verificaciones/'
                }
            },
            urlVideo: '/media/video/introCase3.mp4',
            urlSubtitles: '/media/subtitles/caso3-intro-es.vtt'
        },
        common: {
            scroll: 'Haz scroll',
            conclusion: {
                subMenu: {
                    text1: '¿Quién puede hacer estas verificaciones?',
                    text2: 'VER VIDEO',
                    imgSrc: '/media/image/menuVideoFinalCase.jpg'
                }
            }
        }
    },
    FinalVideo: {
        srcVideo: '/media/video/finalCase.mp4',
        srcSubtitles: '/media/subtitles/final-case-es.vtt',
        urlNext: 'tutoriales/',
        buttonContinue: 'Continuar'
    },
    Documentary: {
        srcVideo: 'https://video-lab.rtve.es/resources/TE_NGVA/mp4/2017/guerra-mentira/documentalES.mp4',
        urlSubtitles: '/media/subtitles/documentalEN.vtt'
    },
    ComingUp: {
        instructions: [{
            txt: 'Estreno del reportaje el lunes 30 de enero a las 23.30h',
            icon: ''
        }, {
            txt: 'Puedes verlo <a href="http://www.rtve.es/directo/la-2/" target="_blank">en La2 y RTVE.es</a>',
            icon: ''
        }],
        buttonContinue: 'Continuar'
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/i18n/es.js
// module id = 823
// module chunks = 0